import script from "./InviteWatch.vue?vue&type=script&setup=true&lang=ts"
export * from "./InviteWatch.vue?vue&type=script&setup=true&lang=ts"

import "./InviteWatch.vue?vue&type=style&index=0&id=f9a889cc&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9a889cc"]])

export default __exports__